<template>
  <div class="IntroPen text-NotoSansRegular BN">
    <!-- BANNER -->
    <div class="pt-12 lg:pt-16 pb-4 md:pb-48 flex-wrap px-8 md:px-12 lg:px-2">
      <div class="max-w-8xl mx-auto flex flex-wrap md:flex-no-wrap">
        <div class="w-full md:w-auto md:px-6 lg:px-8">
          <div class="mb-5 md:mb-16">
            <img src="~@/assets/images/readingPen3/01-master-title.png"
            class="mb-3 md:mb-4 lg:mb-5 max-w-full object-contain w-full md:w-auto" alt="Logo">
          </div>
          <div class="mb-6 hidden md:block">
            <img src="~@/assets/images/readingPen3/01-price-title.png" class="mb-3 md:mb-4 lg:mb-5 max-w-full object-contain w-full md:w-auto" alt="Logo">
          </div>

          <router-link :to="{ name: 'detail', params: { category: 'package', id: 11173 } }" class="cursor-pointer hidden md:block">
            <img src="~@/assets/images/readingPen3/01-Button-order.png"
            class="mb-3 md:mb-4 lg:mb-5 max-w-full object-contain w-4/5 md:w-auto" alt="Logo">
          </router-link>
        </div>
        <div class="w-full md:w-auto mx-auto md:px-6 lg:px-12 xl:px-16 relative z-30">
          <div class="md:hidden">
            <img src="~@/assets/images/readingPen3/01-Livepen-BT-PD02.png" alt="課程朗讀一點就通" class="max-w-full object-contain mx-auto">
          </div>
          <div class="hidden md:block">
            <img src="~@/assets/images/readingPen3/01-Livepen-BT-PD01.png" alt="課程朗讀一點就通" class="max-w-full object-contain mx-auto">
          </div>
          <div class="absolute new_release hidden md:block">
            <img src="~@/assets/images/readingPen3/01-Sticker.png" alt="" class=" object-contain  z-30">
          </div>
        </div>
        <div class="flex items-end mt-6 md:hidden">
          <router-link :to="{ name: 'detail', params: { category: 'package', id: 11173 } }" class="cursor-pointer w-1/2 inline-block">
            <img src="~@/assets/images/readingPen3/01-Button-order.png"
            class="object-contain" alt="Logo">
          </router-link>
          <div class="w-1/2">
            <img src="~@/assets/images/readingPen3/01-price-title2.png" class="object-contain block mx-auto" alt="Logo">
          </div>
        </div>
      </div>
    </div>
    <!-- 課程朗讀一點就通。 -->
    <div class="max-w-8xl mx-auto flex flex-wrap  pt-8 pb-4 md:py-12 px-6">
      <div class="w-full md:w-1/2 order-2 md:order-1 md:px-4 xl:px-0 bg-transparent">
        <div class="video-container" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/pi7Qcs3ZO_k?si=PcGYp3nj5xx_1YxG" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="w-full md:w-1/2 flex flex-col justify-center order-1 md:order-2 mb-4 md:mb-0 md:p-4 lg:p-8">
        <h3 class="text-xl lg:text-3xl md:text-center font-bold ml-1 md:ml-0 text_read_pen3">課程朗讀一點就通</h3>
        <h3 class="text-xl lg:text-3xl md:text-center mb-2 md:mb-4 font-bold ml-1 md:ml-0 text_read_pen3">24小時語言隨身家教</h3>
        <p class="md:text-base lg:text-xl text-center leading-relaxed text_read_pen3">LiveABC智慧點讀筆，使用高品質的光學感應筆頭，書中的單字、句子、段落都可隨點隨聽，走到哪、讀到哪、聽到哪，不受任何時間地點限制，攜帶方便，外型輕巧時尚，符合現代人講究方便、快速、有效的學習需求，一筆在手，學語言練聽力更輕鬆。</p>
      </div>
    </div>
    <!-- 3步驟快速安裝點讀音檔 -->
    <div class="max-w-8xl mx-auto flex flex-wrap bg-white pt-8 pb-4 md:py-12 px-6">
      <div class="w-full md:w-1/2 order-2 md:px-4 xl:px-0">
        <div class="video-container" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/ACa9-P8MbVw?si=zFPCwo-8O768K92-" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="w-full md:w-1/2 flex flex-col justify-center order-1 md:p-4 lg:p-8">
        <h3 class="text-xl lg:text-3xl md:text-center mb-2 md:mb-4 font-bold ml-1 md:ml-0 text_read_pen3">3步驟快速安裝點讀音檔超方便</h3>
        <p class="text-base lg:text-xl text-center leading-relaxed text_read_pen3">點讀筆出廠時會預置部分熱門書籍的點讀音檔，如果聽到No Message或Wow的訊息音，代表記憶卡內沒有音檔，使用者可依實際需求新增或刪除點讀音檔。 更多點讀筆使用常見問題可以點選
          <router-link class="underline text-blue-600" :to="{ name: 'service', params: { id: 'smartPen' } }">Q&A</router-link>。</p>
      </div>
    </div>
    <!-- 高品質光學 感應筆頭 -->
    <div class="p-4 md:p-16 sensitive md:px-6">
      <div class="max-w-8xl mx-auto">
        <div class="w-full mb-4 px-6">
          <h3 class="text-2xl lg:text-3xl md:text-center font-bold mb-2 md:mb-4 text_read_pen3">高品質光學 感應筆頭</h3>
          <p class="text-sm md:text-base lg:text-xl md:text-center leading-relaxed text_read_pen3">以筆尖輕觸頁面上的文字或圖片，即可播放朗讀音檔，隨點隨聽，學習零距離。</p>
        </div>
        <div class="w-full lg:pl-10 mt-6 md:mt-0 flex justify-end"  data-aos="fade-left" data-aos-easing="ease" data-aos-once="false">
          <img src="~@/assets/images/readingPen3/03-Livepen-BT-PD02.png" alt="點讀筆" class="max-w-full object-contain mx-auto">
        </div>
      </div>
    </div>
    <!-- 點讀/錄音/MP3 三機一體 -->
    <div class="combine w-full pt-12 md:pt-0">
      <div class="max-w-8xl mx-auto flex flex-wrap justify-center md:justify-start">
        <div class="w-full md:w-1/2 flex flex-wrap flex-col justify-center px-6">
          <div class="flex justify-center mb-4 px-4 order-2 md:order-1">
            <div class="px-4"><img src="~@/assets/images/readingPen2/icon-02.png" alt="livaABC" class="max-w-full object-contain mx-auto h-16 lg:h-auto" data-aos="fade-right" data-aos-easing="ease" data-aos-once="false"></div>
            <div class="px-4"><img src="~@/assets/images/readingPen2/icon-01.png" alt="livaABC" class="max-w-full object-contain mx-auto h-16 lg:h-auto" data-aos="fade-right" data-aos-easing="ease" data-aos-once="false" data-aos-delay="50"></div>
            <div class="px-4"><img src="~@/assets/images/readingPen2/icon-03.png" alt="livaABC" class="max-w-full object-contain mx-auto h-16 lg:h-auto" data-aos="fade-right" data-aos-easing="ease" data-aos-once="false" data-aos-delay="150"></div>
          </div>
          <div class="order-1 md:order-2 mb-4 text_read_pen3">
            <h3 class="text-xl lg:text-3xl text-center font-bold mb-3 lg:mb-4 text_read_pen3">點讀 | 錄音 | MP3 | 三機一體</h3>
            <p class="text-sm md:text-base lg:text-xl text-center leading-relaxed text_read_pen3">同時具備三大功能，點讀聽原音朗讀、錄音跟讀</p>
            <p class="text-sm md:text-base lg:text-xl text-center leading-relaxed text_read_pen3">開口說、播放課程MP3整段聽。</p>
          </div>
        </div>
        <div class="w-full md:w-1/2 lg:pl-10 mt-6 md:mt-0 flex justify-end"  data-aos="fade-left" data-aos-easing="ease" data-aos-once="false">
          <img src="~@/assets/images/readingPen3/04-Pic-kids.png" alt="點讀筆" class="max-w-full object-contain mx-auto">
        </div>
      </div>

    </div>
    <!-- 附字典卡 輕鬆查單字/LiveABC 出版品通/容量 存書方便 -->
    <div class="max-w-8xl mx-auto flex flex-wrap bg-white py-10 md:py-8 px-6 md:px-12">
      <div class="w-full md:w-1/3 px-2 xl:px-4 flex flex-col" data-aos="fade-top" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen3/05-Pic-01.png" alt="livaABC" class="max-w-full object-contain mx-auto order-3 md:order-1">
        <div class="order-1 md:order-2 bg_read_pen3 h-full">
          <div class="px-4 lg:px-8 py-2 text_read_pen3">
            <p class="text-sm text-center leading-relaxed md:px-2 text_read_pen3">在字典卡上輸入單字字母即可查詢，單字字義唸給你聽。</p>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/3 px-2 xl:px-4 flex flex-col" data-aos="fade-top" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen3/05-Pic-02.png" alt="livaABC" class="max-w-full object-contain mx-auto order-2 md:order-1">
        <div class="order-1 md:order-2 bg_read_pen3 h-full">
          <div class="px-4 lg:px-8 py-2 text_read_pen3">
            <p class="text-sm text-center leading-relaxed mb-1 text_read_pen3">只要是LiveABC出版的可點讀雜誌或叢書<span class="text_read_pen4">(書封右上角有點讀筆圖示)</span>，皆可使用。</p>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/3 px-2 xl:px-4 flex flex-col" data-aos="fade-top" data-aos-easing="ease" data-aos-once="false">
        <img src="~@/assets/images/readingPen3/05-Pic-03.png" alt="livaABC" class="max-w-full object-contain mx-auto order-3 md:order-1">
        <div class="order-1 md:order-2 bg_read_pen3 h-full">
          <div class="px-4 lg:px-8 py-2 text_read_pen3">
            <p class="text-sm text-center leading-relaxed md:px-2 text_read_pen3">16G大容量記憶體，可存超過50本的書籍，出廠時會先預置熱門叢書點讀音檔。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 點讀筆相關說明 -->
    <div class="max-w-8xl mx-auto bg-white pt-4 pb-8 md:pb-12 px-8 md:px-12">
      <div class="mb-4">
        <div class="w-full flex justify-center mb-4 md:mb-6">
          <img src="~@/assets/images/readingPen3/06-title.png" alt="livaABC" class="max-w-full object-contain mb-1">
          <!-- <h3 class="text-xl md:text-2xl lg:text-3xl md:-mb-4 ml-2 introText font-bold whitespace-no-wrap">點讀筆相關說明</h3> -->
        </div>
        <p class="leading-relaxed text-NotoSansLight font-hairline px-4 py-3 rounded-lg tracking-wider text-center max-w-5xl mx-auto text_read_pen3 mb-8">
          點讀筆出廠時，為提供讀者使用上的便利，會預放約30-40本書籍音檔至點讀筆中。但因容量有限，無法將本公司出版之書籍音檔全部放入。倘若您無法點讀該書籍，可至本官網「下載專區」下載點讀音檔放入點讀筆中。若為壓縮檔，請先解壓縮後再存入BOOK資料夾，即可進行點讀。
        </p>
      </div>
        <div class="flex items-center justify-center mb-8 md:mb-6">
          <img src="~@/assets/images/readingPen3/06-livepen-info.png" alt="livaABC" class="object-contain" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
        </div>
    </div>
    <!-- 點讀筆使用範例 -->
    <div class="example py-10 px-4 md:px-12">
      <div class="max-w-8xl mx-auto flex flex-wrap">
        <div class="flex w-full mb-4">
          <img src="~@/assets/images/readingPen3/07-title.png" alt="livaABC" class="object-contain mx-auto">
        </div>
        <div class="w-full">
          <img src="~@/assets/images/readingPen3/07-Pic-flip-book.png" alt="livaABC" class="mx-auto ax-w-full object-contain" data-aos="fade-in" data-aos-easing="ease" data-aos-once="false">
        </div>
        <p class="w-full flex flex-wrap justify-center items-center text-white">
          <span class="text_read_pen3 bg-white p-3 py-2 rounded-md font-semibold m-3">常見問題 Q&A</span>※每本書可點讀的內容依該書編輯規劃為準
        </p>
      </div>
    </div>

    <!-- button -->
    <div class="fixed buy_bg flex justify-center flex-col items-end z-50" >
      <router-link :to="{ name: 'productsList', params: { category: 'livepen' }, query: { scope: 'livepen' } }" target="_blank" class="buy_package block cursor-pointer w-4/5 md:w-auto">
        <!-- <img src="~@/assets/images/readingPen3/menu/01-menu-bar-off_01.png"
          class="max-w-full object-contain off" alt="Logo"> -->
        <img src="~@/assets/images/readingPen3/menu/01-menu-bar-off_01.png"
          class="max-w-full object-contain off" alt="Logo">
        <img src="~@/assets/images/readingPen3/menu/01-menu-bar-on_01.png"
          class="max-w-full object-contain on" alt="Logo">
      </router-link>
      <router-link :to="{ name: 'intro_new2' }" target="_blank" class="buy_package block cursor-pointer w-4/5 md:w-auto">
        <img src="~@/assets/images/readingPen3/menu/01-menu-bar-off_02.png"
          class="max-w-full object-contain off" alt="Logo">
        <img src="~@/assets/images/readingPen3/menu/01-menu-bar-on_02.png"
          class="max-w-full object-contain on" alt="Logo">
      </router-link>
      <router-link :to="{ name: 'detail', params: { category: 'package', id: 11173 } }" class="buy_pen block cursor-pointer w-4/5 md:w-auto">
        <img src="~@/assets/images/readingPen3/menu/01-menu-bar-off_03.png"
          class="max-w-full object-contain off" alt="Logo">
        <img src="~@/assets/images/readingPen3/menu/01-menu-bar-on_03.png"
          class="max-w-full object-contain on" alt="Logo">
      </router-link>
    </div>
    <!-- button -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'IntroPen',
  metaInfo () {
    return {
      title: '點讀筆'
    }
  },
  data () {
    return {
      price: null
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
    this.getPrice()
  },
  updated () {
  },
  methods: {
    toBuySmart () {
      this.$router.push({ name: 'detail', params: { category: 'package', id: 6559 } })
    },
    getPrice () {
      let self = this
      axios.get('/product/6559')
        .then((response) => {
          self.price = response.data.pricing.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }
  .IntroPen {
    margin-top: 173px;
    @media (max-width: 1024px) {
      margin-top: 162px;
    }
    @media (max-width: 1768px) {
      margin-top: 165px;
    }
  }
  .text_read_pen3 {
    color: #173567;
  }
  .text_read_pen4 {
    color: rgb(231, 92, 91);
  }
  .bg_read_pen3 {
    background-color: rgb(120, 224, 215);
  }

  h3, h5, p {
    color: #000000b5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .BN {
    background-image: url('~@/assets/images/readingPen3/BG-01.png');
    @media (max-width: 767px) {
      background-image: url('~@/assets/images/readingPen3/BG-02.png');
    }
    background-origin: center;
    background-position: top center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .new_release {
    top: 50%;
    right: 10%;
    @media (max-width: 768px) {
      width: 50%;
      top: 45%;
      right: 0%;
      width: 150px;
    }
  }

  @media (min-width: 768px) {
    .sensitive {
      background: rgb(255, 252, 207);
    }
  }
  .pb-72 {
    padding-bottom: 26rem;
  }
  .combine {
    background-color: rgb(120, 224, 215);
    // background-image: url('~@/assets/images/readingPen2/BG-02.png');
    // // background-origin: center;
    // background-position: center;
    // background-size: cover;
    // background-repeat: no-repeat;
    // @media (max-width: 767px) {
    //   background-image: url('~@/assets/images/readingPen2/BG-02-m.png');
    // }
  }

  .introText {
    color: #093994;
  }
  .example {
    background-color: rgb(30, 58, 105);
  }
  .text-yellow {
    color: #F5CA00;
  }
  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .buy-Btn {
    transition: .3s;
    color: #000000b5;
    &:hover {
      background: #ff5733 !important;
    }
  }

  .buy_bg {
    right: 6rem;
    top: 11rem;
    @media (max-width: 1440px) {
      right: 1.2rem;
      top: 11em;
    }
    @media (max-width: 1024px) {
      right: 1.5rem;
      top: 11em;
    }
    @media (max-width: 768px) {
      right: 0.5rem;
      top: 11em;
    }
    @media (max-width: 576px) {
      right: 0;
      top: 10em;
    }
    .buy_package {
      .on {
        display: none;
      }
      &:hover {
        .on {
          display: block;
        }
        .off {
          display: none;
        }
      }
    }
    .buy_pen {
      .on {
        display: none;
      }
      &:hover {
        .on {
          display: block;
        }
        .off {
          display: none;
        }
      }
    }
  }
</style>
